<template>
  <h2>Sites</h2>
  <div class="row">
    <div class="col">
      <Button @click="redirectionAjouterSite"> Ajouter</Button>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer</Button>
    </div>
  </div>
  <ResultatSites ref="resultatSites" :entiteLibelles="entiteLibelles" :sites="sites"
                 :isRechercheDataLoading="isRechercheDataLoading" @removeSiteFromList="removeSiteFromList"/>
</template>

<script>
import ResultatSites from "@/components/pilotage/Sites/ResultatSites.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "MenuSite",
  components: {ResultatSites},
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  data() {
    return {
      entiteLibelles: [],
      sites: [],
      isRechercheDataLoading: null,
    }
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Sites");
    this.isRechercheDataLoading = true;
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.dispatch("dossier/rechercherDefaut48HeuresAction").then((res) => {
      this.entiteLibelles = res.data.entiteDecision.entite.libelles;
    });
    this.$store.dispatch("pilotage/rechercherTousSitesAction").then((res) => {
      this.sites = res.data;
    });
  },
  methods: {
    redirectionAjouterSite() {
      this.$router.push({name: 'ajouterSite'});
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    removeSiteFromList(cle) {
      this.sites = this.sites.filter(current => (current.cle != cle))
    }
  }
}
</script>

<style scoped>

</style>